import React, { Suspense, lazy, useEffect } from "react";
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';

import Login from '../components/Login';
import Layout from '../components/Layout';
import { isEmptyJSON } from '../functions/ValidationState';
import { actionCheckAuth } from '../actions/user';
import { bindActionCreators } from "redux";

let HomePage                 = lazy( () => import('./home-route') );
let TypeDocumentPage         = lazy( () => import('./type_document-route'));
let ListDocumentsPage        = lazy( () => import('./list_documents-route'));
let KindDocumentPage         = lazy( () => import('./kind_document-route'));
let GeneralConceptsPage      = lazy( () => import('./general_concepts-route'));
let FormGeneralConceptPage   = lazy( () => import('./form_general_concept-route'));
let ConceptsPage             = lazy( () => import('./concepts-route'));
let FormConceptPage          = lazy( () => import('./form_concept-route'));
let CategoriesPage           = lazy( () => import('./categories-route'));
let FormCategoriePage        = lazy( () => import('./categorie.route'));
let FormTypeDocumentPage     = lazy( () => import('./form-type-document'));
let CategoryDocumentsPage    = lazy( () => import('./category-documents-route'));
let FormCategoryDocumentPage = lazy( () => import('./form-category-document-route'));
let CustomersPage            = lazy( () => import('./customers-route'));
let SettingsPage             = lazy( () => import('./settings-route'));
let IsabiPage                = lazy( () => import('./isabi-route'));
let ConceptsDiscountPage     = lazy( () => import('./concepts-discount-route'));
let PaymentsPage             = lazy( () => import('./payments_route'));
let ManagePermissionsPage    = lazy( () => import('./manage_permissions-route'));
let DashboardPaymentsPage    = lazy( () => import('./dashboard-payments.route'));

function Routes ({ user: { data }, actionCheckAuth }) {

   useEffect( () => {
      actionCheckAuth()
   }, []);

   if ( isEmptyJSON(data) ) {
      return (
         <Suspense fallback = { <span></span> }>
            <Switch>
               <Route exact path = { '/' } component = { HomePage } />
               <Route exact path = { '/documento/:typeDocumentId' }  component = { TypeDocumentPage } />
               <Route exact path = { '/documentos/:typeDocumentId' } component = { ListDocumentsPage } />
               <Route exact path = { '/editar_documento/:typeDocumentId/:documentId' } component = { TypeDocumentPage } />
               <Route exact path = { '/tipo_documentos' } component = { KindDocumentPage } />
               <Route exact path = { '/conceptos_generales' } component = { GeneralConceptsPage } />
               <Route exact path = { '/concepto_general' } component = { FormGeneralConceptPage } />
               <Route exact path = { '/editar_concepto_general/:generalConceptId' } component = { FormGeneralConceptPage } />
               <Route exact path = { '/conceptos' } component = { ConceptsPage } />
               <Route exact path = { '/concepto' } component = { FormConceptPage } />
               <Route exact path = { '/concepto_editar/:conceptId' } component = { FormConceptPage } />
               <Route exact path = { '/categorias' } component = { CategoriesPage } />
               <Route exact path = { '/categoria' } component = { FormCategoriePage } />
               <Route exact path = { '/categoria/:categoryId' } component = { FormCategoriePage } />
               <Route exact path = { '/tipo_documento' } component = { FormTypeDocumentPage } />
               <Route exact path = { '/editar_tipo_documento/:typeDocumentId' } component = { FormTypeDocumentPage } />
               <Route exact path = { '/categoria_documentos' } component = { CategoryDocumentsPage } />
               <Route exact path = { '/categoria_documento' } component = { FormCategoryDocumentPage } />
               <Route exact path = { '/editar_categoria_documento/:categoryDocumentId' } component = { FormCategoryDocumentPage } />
               <Route exact path = { '/clientes' } component = { CustomersPage } />
               <Route exact path = { '/cliente' } component = { CustomersPage } />
               <Route exact path = { '/editar_cliente/:customerId' } component = { CustomersPage } />
               <Route exact path = { '/empresa' } component = { SettingsPage } />
               <Route exact path = { '/banco_honorarios' } component = { SettingsPage } />
               <Route exact path = { '/cuenta_honorario'} component = { SettingsPage } />
               <Route exact path = { '/editar_cuenta_honorario/:bankDetailFeeId' } component = { SettingsPage } />
               <Route exact path = { '/banco_impuestos' } component = { SettingsPage } />
               <Route exact path = { '/cuenta_impuesto' } component = { SettingsPage } />
               <Route exact path = { '/editar_cuenta_impuesto/:bankDetailTaxId' } component = { SettingsPage } />
               <Route exact path = { '/usuarios' } component = { SettingsPage } />
               <Route exact path = { '/usuario' } component = { SettingsPage } />
               <Route exact path = { '/perfil' } component = { SettingsPage } />
               <Route exact path = { '/isabi_impuestos' } component = { IsabiPage } />
               <Route exact path = { '/isabi' } component = { IsabiPage } />
               <Route exact path = { '/editar_isabi/:isabiTaxId' } component = { IsabiPage } />
               <Route exact path = { '/editar_usuario_pass' } component = { SettingsPage } />
               <Route exact path = { '/conceptos_descuento' } component = { ConceptsDiscountPage } />
               <Route exact path = { '/concepto_descuento' } component = { ConceptsDiscountPage } />
               <Route exact path = { '/concepto_descuento_editar/:conceptDiscountId' } component = { ConceptsDiscountPage } />
               <Route exact path = { '/detalles_pago/:typeDocumentId/:documentId/:paymentId' } component = { TypeDocumentPage } />
               <Route exact path = { '/isabis_confirmados' } component = { IsabiPage } />
               <Route exact path = { '/pagos_presupuesto' } component = { PaymentsPage } />
               <Route exact path = { '/administracion_permisos/:userId' } component = { ManagePermissionsPage } />
               <Route exact path = { '/dashboard_pagos' } component = { DashboardPaymentsPage } />
            </Switch>
         </Suspense>
      )

   } else {
      return (
         <Layout>
            <Login />
         </Layout>
      );
   }

}

function mapStateToProps ( state ) {
   return {
      user: state.user
   }
}

function mapDispatchToProps ( dispatch ) {
   return bindActionCreators({
      actionCheckAuth
   }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
